export function joinURL(baseURL: string, ...relativeURLs: string[]) {
  return relativeURLs.reduce(
    (acc, relativeURL) =>
      acc.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, ""),
    baseURL,
  );
}
